import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FormFieldUrlAliasInput = _resolveComponent("FormFieldUrlAliasInput")!
  const _component_FormFieldFileInput = _resolveComponent("FormFieldFileInput")!
  const _component_FormFieldRichTextInput = _resolveComponent("FormFieldRichTextInput")!
  const _component_SeoFieldGroup = _resolveComponent("SeoFieldGroup")!
  const _component_FormFooter = _resolveComponent("FormFooter")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    "tab-id": _ctx.selectedTabId,
    "onUpdate:tab-id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTabId) = $event)),
    title: _ctx.pageTitle,
    "is-content-loading": _ctx.isContentLoading,
    "header-buttons": _ctx.headerButtonList,
    tabs: _ctx.tabList
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_FormFooter, {
        "back-href": _ctx.backButtonUrl,
        "is-submitting": _ctx.isSubmitting,
        "is-creation": _ctx.isCreation,
        "can-create-another": _ctx.isCreation,
        onSubmit: _ctx.submitForm
      }, null, 8, ["back-href", "is-submitting", "is-creation", "can-create-another", "onSubmit"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        novalidate: "",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, [
        (_ctx.selectedTabId === 'common')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_FormField, {
                value: _ctx.values.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.name) = $event)),
                name: "name",
                error: _ctx.errors.name,
                label: "Название"
              }, null, 8, ["value", "error"]),
              (!_ctx.isCreation)
                ? (_openBlock(), _createBlock(_component_FormFieldUrlAliasInput, {
                    key: 0,
                    id: "urlAlias",
                    value: _ctx.values.urlAlias,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.urlAlias) = $event)),
                    name: "urlAlias",
                    label: "URL alias",
                    "url-template": _ctx.pagePath,
                    error: _ctx.errors.urlAlias
                  }, null, 8, ["value", "url-template", "error"]))
                : _createCommentVNode("", true),
              _createVNode(_component_FormFieldFileInput, {
                value: _ctx.values.image,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.image) = $event)),
                label: "Картинка",
                name: "image",
                "file-type": "image"
              }, null, 8, ["value"]),
              _createVNode(_component_FormFieldRichTextInput, {
                value: _ctx.values.content,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.content) = $event)),
                name: "content",
                label: "SEO Текст",
                error: _ctx.errors.content
              }, null, 8, ["value", "error"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.selectedTabId === 'seo')
          ? (_openBlock(), _createBlock(_component_SeoFieldGroup, {
              key: 1,
              title: _ctx.values.pageTitle,
              description: _ctx.values.pageDescription,
              image: _ctx.values.openGraphImage,
              onChange: _ctx.handleSearchEngineOptimization
            }, null, 8, ["title", "description", "image", "onChange"]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["tab-id", "title", "is-content-loading", "header-buttons", "tabs"]))
}